import { Stack } from '@mui/material'
import type { FC } from 'react'
import { useTranslation } from 'react-i18next'

import { DividerWithLabel } from '@hcr/ui'

import { Path } from '../../../../../models/navigation'
import { Link } from '../link'

export const Ownership: FC = () => {
  const { t } = useTranslation()

  return (
    <Stack tabIndex={-1} component='li'>
      <DividerWithLabel component='h2'>{t('account.ownership')}</DividerWithLabel>
      <Link to={Path.Owner} disableBorderBottom={true} title={t('account.holdings')}></Link>
    </Stack>
  )
}
